export default theme => ({
  title: {
    float: 'right',
    color: '#666',
    fontSize: 20,
    fontWeight: 'bold',
    background: '#ffffff',
    padding: '0 10px 0 10px',
    marginTop: theme.spacing.unit,
    marginBottom: 0
  },
  titleLine: {
    position: 'relative',
    left: 0,
    right: 0,
    top: '40%',
    margin: '20px 0 30px',
    height: 0,
    borderBottom: '1px solid #ececec',
    paddingBottom: 35,
  }
})

